import { ICON__list_check, ICON__list_x } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { useMemo } from 'react';

interface PROPS {
  field: FIELD__list_lora;
}

export function G_BUTTON__ml_asset_lora_list__select_all({ field }: PROPS) {
  /*
   *
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */

  const are_all_items_selected = useMemo(() => get_are_all_items_selected(), [field]);

  /*
   *
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_new = field.clone();

    let need_enable_all = !are_all_items_selected;

    let items_new = [];

    for (let token of field.items) {
      let item_new = token.clone();

      item_new.is_enabled.set_value(need_enable_all);

      items_new.push(item_new);
    }

    field_new.items = items_new;

    /*
     *
     */

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }
  /*
   *
   */

  /*
   *
   */
  function get_are_all_items_selected() {
    let is_every_item_enabled = field.items.every(item => item.is_enabled.get_value());

    return is_every_item_enabled;
  }

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   *
   */

  if (field.items.is_empty()) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      size="3-full"
      variant="no-border-on-bar"
      iconClassNameBase="!text-component-item-foreground size-3"
      iconClassNameHovered="!text-bar-foreground"
      {...{ onClick }}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      Icon={are_all_items_selected ? ICON__list_x : ICON__list_check}
    />
  );
}
